import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Percent } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

export const PricingCard = ({ settings, updateField }) => {
  const { t } = useLanguage();
  return (
    <Card className="bg-card border-border">
      <CardContent className="p-6">
        <div className="flex items-center gap-2 mb-6">
          <Percent className="w-5 h-5 text-primary" />
          <h2 className="text-lg font-bold">{t('siteSettings.pricing')}</h2>
        </div>
        <p className="text-sm text-muted-foreground mb-4">{t('siteSettings.pricingHint')}</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <Label className="text-sm">{t('siteSettings.siblingDiscountPercent')}</Label>
            <div className="flex items-center gap-2 mt-1">
              <Input
                type="number" step="1" min="0" max="100"
                value={settings.sibling_discount_percent ?? 10}
                onChange={(e) => updateField('sibling_discount_percent', parseFloat(e.target.value) || 0)}
                className="bg-secondary border-border font-mono"
                data-testid="sibling-discount-input"
              />
              <span className="text-muted-foreground">%</span>
            </div>
            <p className="text-xs text-muted-foreground mt-1">{t('siteSettings.siblingDiscountHint')}</p>
          </div>

          <div>
            <Label className="text-sm">{t('siteSettings.defaultPhotoPrice')}</Label>
            <div className="flex items-center gap-2 mt-1">
              <Input
                type="number" step="0.01" min="0"
                value={settings.default_photo_price ?? 10}
                onChange={(e) => updateField('default_photo_price', parseFloat(e.target.value) || 0)}
                className="bg-secondary border-border font-mono"
                data-testid="default-photo-price-input"
              />
              <span className="text-muted-foreground">CHF</span>
            </div>
            <p className="text-xs text-muted-foreground mt-1">{t('siteSettings.defaultPhotoPriceHint')}</p>
          </div>

          <div className="md:col-span-2">
            <Label className="text-sm">{t('siteSettings.photoRetentionDays')}</Label>
            <div className="flex items-center gap-2 mt-1">
              <Input
                type="number" step="1" min="1" max="365"
                value={settings.photo_retention_days ?? 60}
                onChange={(e) => updateField('photo_retention_days', parseInt(e.target.value, 10) || 60)}
                className="bg-secondary border-border font-mono max-w-[180px]"
                data-testid="photo-retention-days-input"
              />
              <span className="text-muted-foreground">{t('siteSettings.days')}</span>
            </div>
            <p className="text-xs text-muted-foreground mt-1">{t('siteSettings.photoRetentionDaysHint')}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
